<script lang="ts">
	import { BaseList, type BaseListProps, type ListToken } from '../BaseList';

	interface Props {
		token: ListToken;
	}

	let { token }: Props = $props();
	export const options: BaseListProps['options'] = undefined;
	export const renderers: BaseListProps['renderers'] = undefined;
</script>

<BaseList
	{options}
	{renderers}
	{token}
	variant="body3"
	boldVariant="label4"
	class="text-gray-500"
/>
